module.exports = __webpack_public_path__ + "static/img/sam.41c4d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sam.png
// module id = Ue2z
// module chunks = 1